<template>
    <v-container grid-list-md>
        <v-layout row wrap>
            <v-flex xs12 sm4 class="custom_search">
                <v-text-field v-model="search" solo label="Search" maxlength="50" clearable append-icon="search" />
            </v-flex>
            <v-flex xs12 sm4 class="custom_sort">
                <v-select v-model="selectSortDescription" :items="listSortDescription" append-icon="sort" hide-details
                          label="Tri" return-object single-line solo />
                <v-btn @click="orderSort = !orderSort">
                    <v-icon v-if="orderSort">
                        fas fa-long-arrow-alt-up
                    </v-icon>
                    <v-icon v-else>
                        fas fa-long-arrow-alt-down
                    </v-icon>
                </v-btn>
            </v-flex>
            <v-flex id="delete_elements" xs12 sm4 class="custom_search">
                <v-icon v-if="mode !== 'delete'" class="has-text-danger" @click="modeDeleteAugmentations">
                    fas fa-trash-alt
                </v-icon>
                <v-icon v-if="mode === 'delete'" class="has-text-danger" @click="modeResetAugmentations">
                    fas fa-times-circle
                </v-icon>
                <span v-if="mode === 'delete'" class="point has-text-danger cancel_text"
                      @click="modeResetAugmentations">Annuler</span>
                <v-btn v-if="mode === 'delete'" class="delete_btn" @click="validateDeleteAugmentations">
                    Supprimer
                </v-btn>
            </v-flex>
            <v-flex xs12>
                <augmentations-grid :sort="selectSortCallback" :order="orderSort" :search="search" />
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'AugmentationsTabList',
        components: {
            AugmentationsGrid: () => import('./AugmentationsGrid')
        },
        data: () => ({
            search: null,
            listSort: [
                {
                    description: 'Tri par date de mise à jour',
                    callback: (a, b) => {
                        if (b.last_update_date && a.last_update_date) {
                            return b.last_update_date.localeCompare(a.last_update_date);
                        } else {
                            return true;
                        }
                    }
                },
                {
                    description: 'Tri par date de création',
                    callback: (a, b) => {
                        if (a.creation_date && b.creation_date) {
                            return a.creation_date.localeCompare(b.creation_date);
                        } else {
                            return true;
                        }
                    }
                },
                {
                    description: 'Tri par ordre alphabétique',
                    callback: (a, b) => {
                        if (a.name && b.name) {
                            return a.name.localeCompare(b.name);
                        } else {
                            return true;
                        }
                    }
                }
            ],
            selectSortCallback: (a, b) => {
                if (b.last_update_date && a.last_update_date) {
                    return b.last_update_date.localeCompare(a.last_update_date);
                } else {
                    return true;
                }
            }
        }),
        computed: {
            ...mapGetters('augmentations', ['experience', 'augments', 'mode']),
            selectSortDescription: {
                get () {
                    return this.$store.state.augmentations.selectSortDescription;
                },
                set (selectSortDescription) {
                    this.$store.commit('augmentations/SET_SELECT_SORT_DESCRIPTION', selectSortDescription);
                }
            },
            orderSort: {
                get () {
                    return this.$store.state.augmentations.orderSort;
                },
                set (orderSort) {
                    this.$store.commit('augmentations/SET_ORDER_SORT', orderSort);
                }
            },
            listSortDescription: function () {
                return this.listSort.map(x => x.description);
            }
        },
        watch: {
            selectSortDescription: function (newValue) {
                this.selectSortCallback = this.listSort.filter(x => x.description === newValue)[0].callback;
            }
        },
        methods: {
            ...mapActions('augmentations', ['modeDeleteAugmentations', 'modeResetAugmentations', 'validateDeleteAugmentations'])
        },
        mounted () {
            this.selectSortCallback = this.listSort.filter(x => x.description === this.selectSortDescription)[0].callback;
        }
    };
</script>

<style scoped>
    .container {
        padding: 25px;
        max-width: 100% !important;
    }

    .custom_search {
        z-index: 0;
        padding: 5px 10px !important;
    }

    .custom_sort > div:first-child {
        width: calc(100% - 55px) !important;
        display: inline-block;
    }

    .custom_sort > button {
        width: 20px !important;
        min-width: 20px !important;
        display: inline-block;
        height: 48px !important;
        top: -1px;
    }

    #delete_elements {
        height: 60px;
    }

    #delete_elements i {
        float: right;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        color: #FF3860;
    }

    #delete_elements span {
        float: right;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        margin-right: 10px;
        color: #FF3860;
    }

    #delete_elements .delete_btn {
        float: right;
        position: relative;
        top: 50%;
        color: white !important;
        font-weight: 600 !important;
        text-transform: initial !important;
        transform: translateY(-50%);
        margin-right: 10px;
        max-width: 150px;
        background-color: #FF3860;
    }

    .cancel_text {
        cursor: pointer;
    }
</style>
